import * as  common from '@/service/common';
import * as  order from '@/service/order';
export default {
	...common,
	...order
}
